

// $(document).ready(function () {
//         $('.inputcheck').hover(function () {
//             $(this).addClass('fa-times');
//             $(this).removeClass('fa-check-circle'); 
//             $(this).addClass('inputcross');
//             $(this).removeClass('inputcheck'); 
//         }, function () {
//             $(this).addClass('fa-check-circle');
//             $(this).removeClass('fa-times');
//             $(this).addClass('inputcheck');
//             $(this).removeClass('inputcross');
//         });


//     });

// $(document).ready(function () {
//         $('.inputcheckS').hover(function () {
//             $(this).addClass('fa-times');
//             $(this).removeClass('fa-check-circle'); 
//             $(this).addClass('inputcrossS');
//             $(this).removeClass('inputcheckS'); 
//         }, function () {
//             $(this).addClass('fa-check-circle');
//             $(this).removeClass('fa-times');
//             $(this).addClass('inputcheckS');
//             $(this).removeClass('inputcrossS');
//         });


//     });

$(document).ready(function() {

    function updateTabStatus() {
     
      if (document.getElementById("tab1").classList.contains("tab-current")){

        document.getElementById("btnNextxs").style.display = 'block';
        document.getElementById("BtnBack").style.display = 'none';
        document.getElementById("BtnBack2").style.display = 'none';
             document.getElementById("check1").setAttribute('style', 'color: white !important;');
      } else { document.getElementById("check1").setAttribute('style', 'color: #399639; margin-right: 10px;'); }
     
     if (document.getElementById("tab2").classList.contains("tab-current")){

       document.getElementById("btnNextxs").style.display = 'block';
       document.getElementById("BtnBack").style.display = 'block';
       document.getElementById("BtnBack2").style.display = 'block';
       document.getElementById("check2").setAttribute('style', 'color: white !important;');
      } else { document.getElementById("check2").setAttribute('style', 'color: #399639; margin-right: 10px;'); }
     
     if (document.getElementById("tab3").classList.contains("tab-current")){

       document.getElementById("btnNextxs").style.display = 'block';
       document.getElementById("BtnBack").style.display = 'block';
       document.getElementById("BtnBack2").style.display = 'block';
        document.getElementById("check3").setAttribute('style', 'color: white !important;');
      } else { document.getElementById("check3").setAttribute('style', 'color: #399639; margin-right: 10px;'); }
  
     if (document.getElementById("tab4").classList.contains("tab-current")){
       document.getElementById("btnNext").style.display = 'block';
       document.getElementById("btnNextxs").style.display = 'block';
       document.getElementById("BtnBack").style.display = 'block';
       document.getElementById("BtnBack2").style.display = 'block';
        document.getElementById("check4").setAttribute('style', 'color: white !important;');
      } else { document.getElementById("check4").setAttribute('style', 'color: #399639; margin-right: 10px;'); }

     
     if (document.getElementById("tab5").classList.contains("tab-current")){
        document.getElementById("btnNext").style.display = 'none';
       document.getElementById("btnNextxs").style.display = 'none';
       document.getElementById("AddtooCart").style.display = 'block';
       document.getElementById("BtnBack").style.display = 'block';
       document.getElementById("BtnBack2").style.display = 'block';

      }
 
   }
     
     updateTabStatus();

    // Attach the function to the click event
    $(window).on("click", updateTabStatus);
});    



    function myFunctionBack() {
      

      if (document.getElementById("tab2").classList.contains("tab-current")){
      var on = "1";
      var off = "2";                 
      }
      if (document.getElementById("tab3").classList.contains("tab-current")){
      var on = "2";
      var off = "3"; 
      }
      if (document.getElementById("tab4").classList.contains("tab-current")){
      var on = "3";
      var off = "4";  
      }
      if (document.getElementById("tab5").classList.contains("tab-current")){
      var on = "4";
      var off = "5";  
      }


        
      document.getElementById("tab"+on).className = "tab-current";
      document.getElementById("tab"+on).className += " active";
      document.getElementById('section-iconbox-'+on).className = "content-current";
      document.getElementById('section-iconbox-'+on).className += " active";
      
      document.getElementById('section-iconbox-'+off).className = "";
      document.getElementById('tab'+off).className = "";
      
      document.getElementById("AddtooCart").style.display = 'none';
      document.getElementById("btnNext").style.display = 'block';
        
      }
  
  
  
    function myFunctionNext() {
      
      
      if (document.getElementById("tab1").classList.contains("tab-current")){
      var on = "2";
      var off = "1";      
      } 

      
      if (document.getElementById("tab2").classList.contains("tab-current")){
      var on = "3";
      var off = "2";
      }

      
      if (document.getElementById("tab3").classList.contains("tab-current")){
      var on = "4";
      var off = "3";
      }

      
      if (document.getElementById("tab4").classList.contains("tab-current")){
      var on = "5";
      var off = "4"; 
      }

      
      if (document.getElementById("tab5").classList.contains("tab-current")){
      var on = "6";
      var off = "5"; 
      }
      
       if(document.getElementById('shape1').checked) { 
         document.getElementById("ShowDiameter").style.display = 'block';
         document.getElementById("ShowRectangle").style.display = 'none';
         document.getElementById("ShowRectangle1").style.display = 'none';
         document.getElementById("ShowDiameter1").style.display = 'block';
         }
       else {
         document.getElementById("ShowDiameter").style.display = 'none';
         document.getElementById("ShowRectangle").style.display = 'block';
         document.getElementById("ShowRectangle1").style.display = 'block';
         document.getElementById("ShowDiameter1").style.display = 'none';
         }
      
        
      document.getElementById("tab"+on).className = "tab-current";
      document.getElementById("tab"+on).className += " active";
      document.getElementById('section-iconbox-'+on).className = "content-current";
      document.getElementById('section-iconbox-'+on).className += " active";
      
      document.getElementById('section-iconbox-'+off).className = "";
      document.getElementById('tab'+off).className = "";
        
      }  

      
      function myFunctiontab1() {   
      document.getElementById('section-iconbox-2').className = "";
      document.getElementById('section-iconbox-3').className = "";
      document.getElementById('section-iconbox-4').className = "";
      document.getElementById('section-iconbox-5').className = "";  
      document.getElementById('tab2').className = "";
      document.getElementById('tab3').className = "";
      document.getElementById('tab4').className = "";
      document.getElementById('tab5').className = "";  
        document.getElementById("AddtooCart").style.display = 'none';
       document.getElementById("btnNext").style.display = 'block';
        
      }
  
      function myFunctiontab2() {   
      document.getElementById('section-iconbox-1').className = "";
      document.getElementById('section-iconbox-3').className = "";
      document.getElementById('section-iconbox-4').className = "";
      document.getElementById('section-iconbox-5').className = "";  
      document.getElementById('tab1').className = "";
      document.getElementById('tab3').className = "";
      document.getElementById('tab4').className = "";
      document.getElementById('tab5').className = "";  
        document.getElementById("AddtooCart").style.display = 'none';
       document.getElementById("btnNext").style.display = 'block';
      }
      
      function myFunctiontab3() { 
      document.getElementById('section-iconbox-1').className = "";
      document.getElementById('section-iconbox-2').className = "";
      document.getElementById('section-iconbox-4').className = "";
      document.getElementById('section-iconbox-5').className = "";  
      document.getElementById('tab1').className = "";
      document.getElementById('tab2').className = "";
      document.getElementById('tab4').className = "";
      document.getElementById('tab5').className = "";  
        document.getElementById("AddtooCart").style.display = 'none';
       document.getElementById("btnNext").style.display = 'block';
      }

      function myFunctiontab4() { 
      document.getElementById('section-iconbox-1').className = "";
      document.getElementById('section-iconbox-2').className = "";
      document.getElementById('section-iconbox-3').className = "";
      document.getElementById('section-iconbox-5').className = "";  
      document.getElementById('tab1').className = "";
      document.getElementById('tab2').className = "";
      document.getElementById('tab3').className = "";
      document.getElementById('tab5').className = "";  
        document.getElementById("AddtooCart").style.display = 'none';
       document.getElementById("btnNext").style.display = 'block';
      }
  
      function myFunctiontab5() { 
      document.getElementById('section-iconbox-1').className = "";
      document.getElementById('section-iconbox-2').className = "";
      document.getElementById('section-iconbox-3').className = "";
      document.getElementById('section-iconbox-4').className = "";  
      document.getElementById('tab1').className = "";
      document.getElementById('tab2').className = "";
      document.getElementById('tab3').className = "";
      document.getElementById('tab4').className = "";  
        document.getElementById("AddtooCart").style.display = 'block';
      }
      






